// 该文件由 vite-plugin-version-generator 自动生成
// 不要手动编辑此文件，它会在每次构建时自动生成

export const VERSION_INFO = {
  "version": "3.4",
  "major": 3,
  "minor": 4,
  "timestamp": 1793785125134,
  "buildTime": "2026-11-04 17:38:45"
} as const;

export const APP_VERSION = VERSION_INFO.version;
export const BUILD_TIME = VERSION_INFO.buildTime;
export const BUILD_TIMESTAMP = VERSION_INFO.timestamp;
